<div class="field row" *ngIf="value != null">
    <label class="field-label" for="financed-amount" translate="amountFinancedLabel"></label>
    <span class="field-data qa-financed-amount-value" id="financed-amount">{{value | localeCurrency}}</span>
</div>

